<template>
  <div class="ab_showdown">
    <div class="ab_showdown_title">
      <span class="weight_700">
        {{ $t('analyze.hand.showdown') }}
      </span>
    </div>

    <div class="ab_showdown_players">
      <div class="ab_showdown_hero ab_showdown_player">
        <HaPosition :position="hero.position" />

        <div
          v-if="hasWinnings"
          class="ab_showdown_player_winnings"
          :class="hero.amount_won > 0 ? 'clr-primary' : 'clr-error'"
        >
          {{ numFixedUnit(Math.abs(hero.amount_won), 'bb') }} BB
        </div>
        <CardRow
          :hasAnimation="false"
          class="ab_showdown_player_cards card-row_card_distant"
          size="small"
          :cards="hand_hero"
        />
      </div>
      <div
        v-if="opponent && hand_opponent"
        class="ab_showdown_opponent ab_showdown_player"
      >
        <HaPosition :position="opponent.position" />
        <div
          v-if="hasWinnings"
          class="ab_showdown_player_winnings"
          :class="opponent.amount_won > 0 ? 'clr-primary' : 'clr-error'"
        >
          {{ numFixedUnit(Math.abs(opponent.amount_won), 'bb') }} BB
        </div>

        <CardRow
          :hasAnimation="false"
          class="ab_showdown_player_cards card-row_card_distant"
          size="small"
          :cards="hand_opponent"
        />
      </div>
    </div>
  </div>
</template>

<script>
import format_mix from '@/mixins/format_mix'
import HaPosition from '@/components/AnalyzeStreetBlocks/HaPosition'
import CardRow from '@/components/CardRow/CardRow'

export default {
  name: 'HaOpponent',
  components: {
    HaPosition,
    CardRow,
  },
  mixins: [format_mix],
  props: {
    opponent: Object,
    hero: Object,
    hand_hero: String,
    hand_opponent: String,
    hasWinnings: Boolean,
  },
}
</script>

<style lang="scss" scoped>
.ab {
  &_showdown {
    padding-bottom: var(--ha-block-ppadding-unit);
    &_title {
      font-size: var(--ha-street-size);
      font-weight: var(--ha-street-weight);
      margin: var(--ha-street-margin);
    }
    &_players {
      display: flex;
      flex-direction: column;
      gap: var(--ha-gap);
    }
    &_player {
      display: flex;
      &_cards {
        padding-left: 1rem;
      }
      &_winnings {
        padding: 0 0 0 1rem;
        min-width: 6.25rem;
        font-weight: 700;
      }
    }
    &_amount {
      font-weight: 700;
      height: 1.5rem;
      padding-left: 0.25rem;
    }
  }
}
</style>
